import * as React from 'react';
import { connect } from 'react-redux';

const ArcProgressBar = ({ value, width, omega }) => {

    const omegaRadStart = (-omega * Math.PI / 180);
    const omegaRadEnd = (Math.PI * (1 + omega / 180));
    const radius = 20;
    const innerRadius = (width * 30);
    const coonerRadius = (radius - innerRadius) / 2;
    const omegaRadValue = omegaRadStart + (omegaRadEnd - omegaRadStart) * value;
    const xyPoint = (r, angle) => [Math.cos(angle), Math.sin(angle)].map(x => 50 - (x * r))
    const [x1Start, y1Start] = xyPoint(radius, omegaRadStart);
    const [x2Start, y2Start] = xyPoint(innerRadius, omegaRadStart);
    const [x1End, y1End] = xyPoint(radius, omegaRadEnd);
    const [x2End, y2End] = xyPoint(innerRadius, omegaRadEnd);
    const [x1Value, y1Value] = xyPoint(radius, omegaRadValue);
    const [x2Value, y2Value] = xyPoint(innerRadius, omegaRadValue);

    var v: number = value;

    let viewBag = "-50 30 200 40";
    if (window.innerWidth <= 300) {
        viewBag = "30 30 40 40";
    } else if (window.innerWidth <= 350) {
        viewBag = "30 30 40 40";
    } else if (window.innerWidth <= 450) {
        viewBag = "25 30 50 40";
    } else if (window.innerWidth <= 550) {
        viewBag = "10 30 80 40";
    } else if (window.innerWidth <= 768) {
        viewBag = "-20 30 140 40";
    } else if (window.innerWidth <= 1024) {
        viewBag = "-20 30 140 40";
    }

    if (v <= 0.6) {
        return (
            <svg viewBox={viewBag}>
                <path
                    d={`
                         M ${x1Start} ${y1Start}
                         A ${radius} ${radius} 0 1 1 ${x1End} ${y1End}
                         A ${coonerRadius} ${coonerRadius} 0 1 1 ${x2End} ${y2End} 
                         A ${innerRadius} ${innerRadius} 0 1 0 ${x2Start} ${y2Start} 
                         A ${coonerRadius} ${coonerRadius} 0 0 1 ${x1Start} ${y1Start}
                         Z`}
                    fill="#E6E6E6"
                />
                <path
                    d={`
                         M ${x1Start} ${y1Start}
                         A ${radius} ${radius} 0 0 1 ${x1Value} ${y1Value}
                         A ${coonerRadius} ${coonerRadius} 0 1 1 ${x2Value} ${y2Value} 
                         A ${innerRadius} ${innerRadius} 0 0 0 ${x2Start} ${y2Start} 
                         A ${coonerRadius} ${coonerRadius} 0 1 1 ${x1Start} ${y1Start}
                         Z`}
                    fill="#B10F1F"
                />
            </svg>
        );
    }
    else {
        return (<svg viewBox={viewBag}>
            <path
                d={`
                     M ${x1Start} ${y1Start} 
                     A ${radius} ${radius} 0 1 1 ${x1End} ${y1End}  
                     A ${coonerRadius} ${coonerRadius} 0 1 1 ${x2End} ${y2End} 
                     A ${innerRadius} ${innerRadius} 0 1 0 ${x2Start} ${y2Start} 
                     A ${coonerRadius} ${coonerRadius} 0 0 1 ${x1Start} ${y1Start}
                     Z`}
                fill="#E6E6E6"
            />
            <path
                d={`
                     M ${x1Start} ${y1Start} 
                     A ${radius} ${radius} 0 1 1 ${x1Value} ${y1Value}  
                     A ${coonerRadius} ${coonerRadius} 0 1 1 ${x2Value} ${y2Value} 
                     A ${innerRadius} ${innerRadius} 0 1 0 ${x2Start} ${y2Start} 
                     A ${coonerRadius} ${coonerRadius} 0 0 1 ${x1Start} ${y1Start}
                     Z`}
                fill="#B10F1F"
            />
        </svg>)
    }
};

export default connect()(ArcProgressBar);